import React, { Component } from 'react';
import 'rc-dialog/assets/bootstrap.css';


class Limites extends Component {

    constructor(props) {
        super(props);

        this.state = {
            LimiteCompra: this.props.dataTarjetas.limiteCompra,
            CLCC: this.props.dataTarjetas.CLCC
        };
        this.onLimiteCompraChange = this.onLimiteCompraChange.bind(this);
        this.onCLCCChange = this.onCLCCChange.bind(this);
        this.onCLCCBlur = this.onCLCCBlur.bind(this);
    }

    onLimiteCompraChange(value) {
        let regularExpression = new RegExp("^[0-9]+$");
        if(regularExpression.test(value) || value == ""){
            this.setState({LimiteCompra: value},()=>this.props.onBlurTextBox("limiteCompra",value))
        }
    }

    onCLCCChange(value) {
        if ( /^\d{0,1}(\.\d{1,2})?$/.test(value) || (!isNaN(value.substring(0,value.length-2)) && value[value.length-1] == ".")|| value === "") {
            this.setState({CLCC: value},()=>this.props.onBlurTextBox("CLCC",value))
        }
    }

    onCLCCBlur(value){
        if(value[value.length-1] == "."){
            this.setState({CLCC: parseInt(value)},()=>this.props.onBlurTextBox("CLCC",parseInt(value)))
        }
    }

    componentWillReceiveProps(nextProps){
        let {tarjetas,onBlurTextBox,data} = this.props;

        //SI SE TRATA DE UNA MODIFICACIÓN, UNA VEZ CARGADOS TODOS LOS DATOS DE PRODUCTO SE PROCEDE A CARGAR LAS SELECCIONES DE LA SOLICITUD A MODIFICAR
        if( !this.props.tarjetas.vuelveDeAdicional && tarjetas.solicitudCuenta.GET_PRODUCTO_CABAL_PRODUCTO_ID && tarjetas.solicitudCuenta.GET_PRODUCTO_CABAL_PRODUCTO_ID.Id && tarjetas.esModificacion && !data.limitesModificacion){
            let limiteC = tarjetas.datosSolicitud.ImporteLimiteCompra;
            let flcc = tarjetas.datosSolicitud.FactorLimiteCompraCuotas ? tarjetas.datosSolicitud.FactorLimiteCompraCuotas : null;
            
            this.setState({ LimiteCompra: limiteC });
            onBlurTextBox("limiteCompra", limiteC);
                    
            //SI HAY FLCC SE CARGA EL MISMO
            if(flcc){
                this.setState({ CLCC: flcc });
                onBlurTextBox("CLCC", flcc);
            }

            //SI LOS VALORES CORRESPONDIENTES FUERON CARGADOS SE PASA EL FLAG A TRUE
            if(( data.limiteCompra == limiteC) && ((flcc && data.CLCC == flcc) || !flcc && limiteC)){
                this.props.cargarDatosModificacion("limitesModificacion")
            }
            
        }
        
        //SI NO SE TRATA DE UNA MODIFICACIÓN, SE CARGAN LOS VALORES DEFAULT
        if(this.props.tarjetas.esModificacion == false){
            if(data.GET_PRODUCTO_CABAL_PRODUCTO_ID.Id && this.props.productoDefault && this.props.productoDefault.LimiteCompraDefaultInterfaz && (data.limiteCompra == undefined )){
                this.props.onBlurTextBox("limiteCompra",this.props.productoDefault.LimiteCompraDefault);
            }
            if(data.GET_PRODUCTO_CABAL_PRODUCTO_ID.Id && this.props.productoDefault && this.props.productoDefault.CLCCDefaultInterfaz && data.CLCC == undefined){
                this.props.onBlurTextBox("CLCC",this.props.productoDefault.CLCCDefault);
            }
        }
    }

    render() {
        const { onLimiteCompraChange, onLimiteCompraBlur } = this;
        const { data, dataTarjetas, producto } = this.props;

        let permiteCLCC = this.props.parametros.SINOFACTORLIMITECOMPRACUOTA
        let CLCCdesde = producto && producto.CLCCDesde ? producto.CLCCDesde : 0
        let CLCChasta = producto && producto.CLCCHasta ? producto.CLCCHasta : 0
        let limiteMin = this.props.producto ? this.props.producto.LimiteCompraDesde : 0
        let limiteMax = this.props.producto ? this.props.producto.LimiteCompraHasta : 0

        let limiteMinMostrar = ""
        let limiteMaxMostrar = ""
        let CLCCDesdeMostrar = ""
        let CLCCHastaMostrar = ""
        
        let errorLimite

        CLCCDesdeMostrar = CLCCdesde.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
        CLCCHastaMostrar = CLCChasta.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
        
        limiteMinMostrar = limiteMin && limiteMin.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
        limiteMaxMostrar = limiteMax && limiteMax.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');


        if(data.limiteCompra && limiteMin && limiteMax){
            errorLimite = !(parseInt(data.limiteCompra) >= parseInt(limiteMin) && parseInt(data.limiteCompra) <= parseInt(limiteMax))

        }

        let errorCLCC
        if(data.CLCC && permiteCLCC && CLCCdesde && CLCChasta){
            errorCLCC = !(parseInt(data.CLCC) >= parseInt(CLCCdesde) && parseInt(data.CLCC) <= parseInt(CLCChasta))
        }
        
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="row bottom-separator-xs">
                        <div className="correspondencia-contacto-cliente col-md-12">
                            <div className="divisor-section bottom-separator" >
                                <h2>Límites</h2>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <label className="funcionamiento-limites-input"> Límite de Compra </label>
                            <input type="text"
                                maxLength={9}
                                value={dataTarjetas.limiteCompra}
                                className="input-separate"
                                placeholder="Ingrese Monto..."
                                onChange={e=>this.onLimiteCompraChange(e.target.value)}
                                 />
                            <label className="funcionamiento-limites-input"> Entre ${limiteMinMostrar} y ${limiteMaxMostrar}</label>
                        </div>
                        {(!data.ERROR_CUENTA.limiteCompra && !errorLimite) && <div className="col-md-12">
                            <label className="error">{"Debe ingresar un límite de compra."}</label>
                        </div> }
                        {(!data.ERROR_CUENTA.limiteCompra && errorLimite) && <div className="col-md-12">
                            <label className="error">{"El límite de compra debe estar entre los valores mínimo y máximo definidos por el producto."}</label>
                        </div> }                        
                    </div>
                    {permiteCLCC && <div className="form-group bottom-separator-xs">
                    <div className="row">
                        <div className="col-md-12">
                            <label className="label-primary">CLCC Límite de Compra en Cuotas</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <label className="funcionamiento-limites-input">Coeficiente</label>
                            <input type="text"
                                maxLength={3}
                                value={dataTarjetas.CLCC}
                                className="input-separate-short inputAlta"
                                onChange={e=>this.onCLCCChange(e.target.value)}
                                onBlur={e=>this.onCLCCBlur(e.target.value)}
                                 />
                            <label className="funcionamiento-limites-input"> (entre {CLCCDesdeMostrar} y {CLCCHastaMostrar})</label>
                        </div>
                        <div className="col-md-12">
                            {(errorCLCC && !data.ERROR_CUENTA.factorLimiteCompra) &&  <label className="error">{"Debe ingresar un coeficiente entre el mínimo y el máximo permitido por el producto."}</label>}
                            {(!errorCLCC && !data.ERROR_CUENTA.factorLimiteCompra) && <label className="error">{"Debe ingresar un coeficiente."}</label>}
                        </div>
                    </div>
                    </div>}
                </div>
            </div>
        )
    }
}

export default Limites;